export default __webpack_public_path__ + "static/media/light-estimate-checkmark.010e8134.svg";